export function redirectParent(url: string): void {
  window.parent.postMessage(JSON.stringify({ type: 'openTab', url }), '*');
}
